import {getIsAgeRestricted} from '../../../../common/getIsAgeRestricted';
import {PosterViewItem} from '../../../../design-system/organisms/PosterViewItem/PosterViewItem';
import {
  GroupType,
  PosterViewItem as PosterViewItemType,
} from '../../../../graphql/generated/types';
import {LOG_SERIES_CLICK} from '../../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {useLogin} from '../../../../user/useLogin.hook';
import {CommonItemProps} from '../../type';

export function CleanView({item, parentGroup}: CommonItemProps) {
  const {
    thumbnail,
    scheme,
    ageGrade,
    badgeList,
    ageGradeBadge,
    statusBadge,
    title,
    altText,
    subtitleList,
    showPlayerIcon,
    selfCensorship,
    eventLog,
    discountRateText,
    statusLabelText,
  } = item as PosterViewItemType;
  const {user} = useLogin();

  return (
    <PosterViewItem
      {...putTiaraObjectProps(eventLog)}
      onClickCapture={LOG_SERIES_CLICK}
      title={title || ''}
      altText={altText || ''}
      posterSrc={thumbnail}
      badgeList={badgeList}
      statusBadge={statusBadge}
      statusLabelText={statusLabelText}
      subtitleList={subtitleList}
      ageGradeBadge={ageGradeBadge}
      isAgeRestricted={getIsAgeRestricted({
        age: user?.age,
        authenticatedAt: user?.authenticatedAt,
        ageGrade,
        selfCensorship,
      })}
      scheme={scheme}
      showPlayerIcon={showPlayerIcon}
      imageLazyLoad={false}
      className={
        parentGroup.type === GroupType.HorizontalScroll ? 'w-98pxr' : ''
      }
      discountRateText={discountRateText}
    />
  );
}
